export enum REDIRECT_TYPES {
  REPLACE = "REPLACE",
  PUSH = "PUSH",
}
